import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const SurveyTemplateCategoryProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers(); 

    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'Survey/GetSurveyTemplateCategoryTypes', method: 'GET', secure: true });
    }, [execute]); 

    const value = { listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useSurveyTemplateCategoryStore = () => React.useContext(Context);
